module.exports = __webpack_public_path__ + "7d37cbe354a6ab55a6c386f4135bf6bd.svg";